var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimerPlayBtn = function SvgTimerPlayBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 10 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.129 7.495-6.532 3.771c-1.15.665-2.59-.166-2.59-1.495V2.23c0-1.33 1.44-2.16 2.59-1.495l6.532 3.771c1.15.665 1.15 2.326 0 2.99"
  })));
};
export default SvgTimerPlayBtn;